<template>
  <BaseWrapper :loading="loadingRetur">
    <div class="space-y-4">
      <CreateReturForm :disabled="!!retur.id" v-model="retur" />
      <CreateReturDetailForm
        v-if="retur.office.id"
        :source="retur.returSource"
        :origin-warehouse-id="retur.office.currentWarehouse.id"
        :origin-office-id="retur.office.id"
        :create-retur-attributes="{
          shipment_type: retur.shipmentType,
          is_using_stocks: retur.usingStock,
          retur_source: retur.returSource,
        }"
        :retur-id="retur.id"
        v-model="items"
        @retur-created="onReturCreated"
      />
      <div class="flex justify-end gap-2">
        <BaseButton :disabled="!valid" @click="confirmValidateVisible = true">
          <Icon icon="heroicons:shield-check-solid" class="h-4 w-4" />
          Siap Validasi
        </BaseButton>
        <BaseButton color="white" :to="{ name: 'retur.stockist' }">
          <Icon icon="heroicons:arrow-uturn-left" class="h-4 w-4" />
          Kembali
        </BaseButton>
      </div>
    </div>

    <BaseConfirm
      :visible="confirmValidateVisible"
      icon-type="badge"
      type="success"
      title="Validasi Retur"
      message="Retur yang divalidasi akan dilanjutkan ke gudang, validasi?"
      confirm-text="Validasi"
      @close="confirmValidateVisible = false"
      @confirmed="onValidate"
    />
  </BaseWrapper>
</template>
<script>
import CreateReturForm from '../../../../../components/retur/create-retur-form.vue';
import CreateReturDetailForm from '../../../../../components/retur/create-retur-detail-form.vue';
import { requestMixin } from '../../../../../mixins/request/request';
import BaseConfirm from '../../../../../components/base/BaseConfirm.vue';

export default {
  mixins: [requestMixin],
  components: {
    CreateReturForm,
    CreateReturDetailForm,
    BaseConfirm,
  },
  data() {
    return {
      confirmValidateVisible: false,
      loadingRetur: false,
      retur: {
        id: null,
        date: new Date(),
        office: {
          id: null,
          code: null,
          searchCode: null,
          originalCode: null,
          name: null,
          currentWarehouse: {
            id: null,
            code: null,
          },
          area: {
            id: null,
            code: null,
          },
        },
        shipmentType: 'pickup',
        usingStock: true,
        returSource: 'stock',
      },
      items: [
        {
          id: null,
          orderId: null,
          orderCode: null,
          orderOriginalCode: null,
          productId: null,
          productType: null,
          productCode: null,
          productOriginalCode: null,
          productName: null,
          stockQty: null,
          qty: null,
          originalQty: null,
          orderedQty: null,
          weight: null,
          pointValue: null,
          bonusValue: null,
        },
      ],
    };
  },
  computed: {
    valid() {
      return (
        this.items.length && this.items.every((item) => !item.id || item.qty)
      );
    },
  },
  methods: {
    async loadRetur(id) {
      this.loadingRetur = true;

      const [res, err] = await this.request(`/api/v1/returs/${id}`, {
        params: {
          include: 'origin-office,origin-warehouse,details',
          'fields[returs]':
            'createdAt,shipment_type,is_using_stocks,origin-office,origin-warehouse,details,retur_source',
          'fields[offices]': 'code,name,area_code',
          'fields[warehouses]': 'code',
          'fields[retur-details]':
            'order_id,order_origin_code,product_id,product_type,product_code,product_name,current_stock,product_qty,product_weight,product_point,product_bonus,product_ordered_qty',
        },
      });

      if (!err) {
        this.retur.id = res.data.id;
        this.retur.date = res.data.attributes.createdAt;
        this.retur.shipmentType = res.data.attributes.shipment_type;
        this.retur.usingStock = res.data.attributes.is_using_stocks;
        this.retur.returSource = res.data.attributes.retur_source;

        const originOffice = this.getSingleIncluded(
          res,
          res.data.relationships['origin-office'].data.id
        );
        const originWarehouse = this.getSingleIncluded(
          res,
          res.data.relationships['origin-warehouse'].data.id
        );

        this.retur.office.id = originOffice.id;
        this.retur.office.code = originOffice.attributes.code;
        this.retur.office.searchCode = originOffice.attributes.code;
        this.retur.office.originalCode = originOffice.attributes.code;
        this.retur.office.name = originOffice.attributes.name;

        this.retur.office.currentWarehouse.id = originWarehouse.id;
        this.retur.office.currentWarehouse.code =
          originWarehouse.attributes.code;

        this.retur.office.area.id = originOffice.attributes.area_code;
        this.retur.office.area.code = originOffice.attributes.area_code;

        const items = this.getIncludedByType(res, 'retur-details');

        this.items = items.map((item) => ({
          id: item.id,
          orderId: item.attributes.order_id,
          orderCode: item.attributes.order_origin_code,
          orderOrginalCode: item.attributes.order_origin_code,
          productId: item.attributes.product_id,
          productType: item.attributes.product_type,
          productCode: item.attributes.product_code,
          productOriginalCode: item.attributes.product_code,
          productName: item.attributes.product_name,
          stockQty: item.attributes.current_stock,
          qty: item.attributes.product_qty,
          originalQty: item.attributes.product_qty,
          orderedQty: item.attributes.product_ordered_qty,
          weight: item.attributes.product_weight,
          pointValue: item.attributes.product_point,
          bonusValue: item.attributes.product_bonus,
        }));

        this.items.push({
          id: null,
          orderId: null,
          orderCode: null,
          orderOriginalCode: null,
          productId: null,
          productType: null,
          productCode: null,
          productOriginalCode: null,
          productName: null,
          stockQty: null,
          qty: null,
          originalQty: null,
          orderedQty: null,
          weight: null,
          pointValue: null,
          bonusValue: null,
        });
      }

      this.loadingRetur = false;
    },
    onReturCreated(retur) {
      this.$router.push({
        name: 'retur.stockist.edit',
        params: {
          id: retur.data.id,
        },
      });

      this.retur.id = retur.data.id;
    },
    async onValidate() {
      this.loadingRetur = true;

      const [, err] = await this.request(
        `/api/v1/returs/${this.retur.id}/-actions/validate-retur`,
        {
          method: 'patch',
        }
      );

      if (!err) {
        this.$router.push({ name: 'retur.stockist' });
      }

      this.loadingRetur = false;
    },
  },
  created() {
    if (this.$route.params.id) {
      this.loadRetur(this.$route.params.id);
    }
  },
};
</script>
